import { fetchApi } from './fetchApi'
import { paths } from './generated/oauth-user'

type Method = paths['/oauth/user']
type Response = Method['get']['responses']['200']['schema']

export const authSocialApi = () => {
  return fetchApi<Response>('/oauth/user')
}
